<template lang="pug">
  v-container.pa-0
    v-layout(row align-center).pl-2
      v-flex(xs2 sm2 md2 lg2 xl1)
        v-layout(justify-start align-center)
          v-icon.rounded-background(
            :color="acesso.dadosDeAcessoConsistentes ? '#279FE0': '#E02D38'"
            :style="corDoRoundedBackground"
          ) home
      v-flex(xs5 sm5 md5 lg5 xl5)
        v-layout(justify-center align-center)
          span.acesso-title-text(
            :style="corDoTexto"
          ) Titular:
          span.acesso-text(
            :style="corDoTexto"
          ) {{ acesso.pessoaComAcessoVigente }}
      v-flex(xs1 sm1 md1 lg1 xl1)
        v-layout(justify-center align-end)
          div.vertical-divider(:style="verticalDividerStyle")
      v-flex(xs5 sm5 md5 lg5 xl5)
        v-layout(justify-center align-center)
          span.acesso-title-text(
            :style="corDoTexto"
          ) Acesso:
          span.acesso-text(
            :style="corDoTexto"
          ) {{ acesso.pessoaPresenteNoImovel }}
    v-layout(row)
      v-flex(md6)
        v-layout.py-1(justify-center column)
          v-flex(xs12).my-0
            .consistencia-tempo Verificado em: {{ computedDate }} às {{ computedTime }}
          v-flex(xs12 md6).pa-0
            v-btn.sync-button(
              depressed
              block
              color="#2CB5FF"
              @click="emitClick($event)"
              :loading="loading"
            )
              v-layout(justify-center align-center)
                v-icon.mr-2(color="white" small) sync
                span.sync-button-text Sincronizar manualmente
      v-flex.d-flex.pa-1(
        justify-end
        align-end
        md6
      )
        v-btn.sync-button(
              depressed
              block
              color="#2CB5FF"
              @click="$emit('generate-period-code')"
              :loading="loading"
            )
              v-layout(justify-center align-center)
                v-icon.mr-2(color="white" small) add
                span.sync-button-text Gerar código do período
</template>

<script>
import Moment from 'moment';

export default {
  name: 'Consistencia',
  props: {
    acesso: {
      type: Object,
      default() {
        return {};
      },
    },
    loading: {
      type: Boolean,
    },
  },
  computed: {
    computedDate() {
      return Moment(this.acesso.consultadoEm).format('DD/MM/YYYY');
    },
    computedTime() {
      return Moment(this.acesso.consultadoEm).format('HH:mm');
    },
    corDoTexto() {
      return this.acesso.dadosDeAcessoConsistentes ? 'color: #2CB5FF' : 'color: #E02D38';
    },
    corDoRoundedBackground() {
      return this.acesso.dadosDeAcessoConsistentes ? 'background-color: #F7FAFD; border: 0.1vh solid #CCEDFF' : 'background-color: #FFE3E3; border: 0.1vh solid #F86A6A';
    },
    verticalDividerStyle() {
      return this.acesso.dadosDeAcessoConsistentes ? 'border: 0.1vh solid #CCEDFF' : 'border: 0.1vh solid #FFE3E3';
    },
  },
  methods: {
    emitClick(event) {
      this.$emit('click', event);
    },
  },
};
</script>

<style lang="sass">
  .rounded-background
    height: 4.0vh
    width: 4.0vh
    border-radius: 50%
  .acesso-title-text
    font-size: 1.4vh
    font-weight: bold
    color: #2CB5FF
  .acesso-text
    font-size: 1.4vh
    margin-left: 0.2vh
    white-space: nowrap
    text-overflow: ellipsis
    overflow: hidden
  .vertical-divider
    margin-top: 15%
    width: 1.8vh
    transform: rotate(90deg)
  .sync-button-text
    text-transform: none
    font-style: normal
    font-weight: normal
    font-size: 1.4vh
    line-height: 1.6vh
    color: #FAFDFF
  .sync-button
    border-radius: 0.4vh
  .consistencia-tempo
    font-size: 1.2vh
    line-height: 1.4vh
    color: #BFBFBF
</style>



// WEBPACK FOOTER //
// src/app/Dashboard/components/Consistencia.vue